var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "timer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.75 1.88135H11.25V4.38135H18.75V1.88135ZM13.75 18.1313H16.25V10.6313H13.75V18.1313ZM23.7875 9.85635L25.5625 8.08135C25.025 7.44385 24.4375 6.84385 23.8 6.31885L22.025 8.09385C20.0875 6.54385 17.65 5.61885 15 5.61885C8.7875 5.61885 3.75 10.6563 3.75 16.8688C3.75 23.0813 8.775 28.1188 15 28.1188C21.225 28.1188 26.25 23.0813 26.25 16.8688C26.25 14.2313 25.325 11.7938 23.7875 9.85635ZM15 25.6313C10.1625 25.6313 6.25 21.7188 6.25 16.8813C6.25 12.0438 10.1625 8.13135 15 8.13135C19.8375 8.13135 23.75 12.0438 23.75 16.8813C23.75 21.7188 19.8375 25.6313 15 25.6313Z",
    fill: "#DEDFEC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.30d0fdcda96e8a9ee4f0c1b2025914fe.svg";
export { ForwardRef as ReactComponent };